import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import ThemeContext from "./context/ThemeContext";
import { ToastrProvider } from "./components/Provider/ToastrProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter basename="/">
      <ThemeContext>
        <ToastrProvider>
          <App />
        </ToastrProvider>
      </ThemeContext>
    </BrowserRouter>
  </React.StrictMode>
);
reportWebVitals();
